import { render, staticRenderFns } from "./TheCategoriesSearch.vue?vue&type=template&id=3fec5f28&"
import script from "./TheCategoriesSearch.vue?vue&type=script&lang=js&"
export * from "./TheCategoriesSearch.vue?vue&type=script&lang=js&"
import style0 from "./TheCategoriesSearch.vue?vue&type=style&index=0&id=3fec5f28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports